<template>
  <div :class="$style['pt-adult-sell-order-detail']">
    <pt-page-title title="订单详情"></pt-page-title>
    <pt-sub-title title="订单状态">
      <span slot="line" style="color:red;margin-left:10px;" v-if="order && showWarning">{{warningInfo}}</span>
      <pt-legend :statusArray="statusArray"></pt-legend>
    </pt-sub-title>
    <!-- 步骤条 -->
    <pt-lab-order-progress :class="$style['order_progress']" :order-status="statuses" :task="task" :order-detail="order"
      :tasks="tasks"></pt-lab-order-progress>
    <!-- 状态操作需补充 -->
    <template v-if="order && HAS_PERM_ADULTLAB_OPERATION">
      <order-status :order-detail="order" :task="task" :status="nextStatus" :order="order"
        v-if="!this.$route.params.approval" @status-change="reload" :order-status="statuses" @isLoading="isLoading"
        :hideForm="this.orderflowHelper.canNotOperation(this.nextStatus,this.order)">
        <!-- <a style="margin-left:20px;" v-if="order.reportJobId && nextStatus==='REPORT_CHECKED_1ST'">
          <el-button @click="showReport=true" size="small" type="primary">查看在线报告</el-button>
        </a> -->
      </order-status>
      <p v-else style="height:10px;"></p>
    </template>
    <!-- 样本信息 -->
    <pt-sub-title title="样本及用户信息"></pt-sub-title>
    <wt-grid :col="4" grid-gap="10px" :class="$style['order-info__box']" v-if="order">
      <wt-box :class="$style['order-info']">
        <span>合同编号：{{order.otherInfo.contractNumber ? order.otherInfo.contractNumber : '--'}}</span>
        <span>样本条码号：{{order.sampleId ? order.sampleId : '--'}}</span>
        <span>样本类型：{{order.currentSample.sampleType ? getEnumeration(order.currentSample.sampleType,sampleType) : '--'}}</span>
        <span>采集日期：{{order.currentSample.collectTime ? formatDate(order.currentSample.collectTime) :'--'}}</span>
        <span>采集医院：{{order.hospital ? order.hospital.name :'--'}}</span>
        <span>牙齿颗数：{{order.otherInfo.numberOfTeeth ? order.otherInfo.numberOfTeeth :'--'}}</span>
        <span v-if="order.collectTimes!==null">采集次数：第{{order.collectTimes}}次</span>
      </wt-box>
      <wt-box :class="$style['order-info']" v-if="orderDetail.length">
        <span v-for="(item,index) in orderDetail" :key="index">{{item.name+'：'+item.text}}</span>
      </wt-box>
      <wt-box :class="$style['order-info']">
        <span>受检者姓名：{{order.patient.name ? order.patient.name :'--'}}</span>
        <span>性别：{{order.patient.gender ? genderFormat(order.patient.gender) : '--'}}</span>
        <span>受检者身份证号：{{order.patient.identityCard ? order.patient.identityCard:'--'}}</span>
        <span>受检者民族：{{order.patient.nation ? order.patient.nation :'--'}}</span>
        <span>手机号：{{order.patient.mobile ? order.patient.mobile :'--'}}</span>
        <span>出生日期：{{order.patient.birthday ? formatDate(order.patient.birthday) :'--'}}</span>
        <span>年龄：{{order.patient.age === 0 ? 0 : (order.patient.birthday || order.patient.age ?  order.patient.age || birthdayToAge(order.patient.birthday):'--')}}</span>
        <span v-if="order.otherInfo.businessOriginArea">地区：{{order.otherInfo.businessOriginArea}}</span>
      </wt-box>
      <wt-box :class="$style['order-info']">
        <span>C端用户：<span>{{order.otherInfo.mallOrderPlacerNickName ? order.otherInfo.mallOrderPlacerNickName :'--'}}</span></span>
        <span>手机号：{{order.otherInfo.mallOrderPlacerPhone ? order.otherInfo.mallOrderPlacerPhone :'--'}}</span>
        <span v-if="order.orderStatusEnum === 'COMPLETED'">
          <template v-if="hasSample">
          <span v-if="reportVisable">C端报告：已对用户可见 <span :class="$style.aColor" @click="toOperation"> 隐藏</span></span>
          <span v-if="!reportVisable">C端报告：已对用户隐藏 <span :class="$style.aColor" @click="toOperation"> 展示</span></span>
          </template>
          <template v-else>
            <span>该实验室订单在C端暂无样本 </span>
          </template>
        </span>
      </wt-box>
    </wt-grid>
    <!-- 订单信息 -->
    <pt-sub-title title="订单信息"></pt-sub-title>
    <wt-grid :col="3" grid-gap="10px" :class="$style['order-info__box']" v-if="order">
      <wt-box :class="$style['order-info']">
        <span>商品名称：{{order.detectionPackageNames ? order.detectionPackageNames.toString() : '--'}}</span>
        <span>商品编号：{{order.agentProductCode ? order.agentProductCode : '--'}}</span>
        <span>订单来源：{{order.salesFrom ? formatSaleFrom(order.salesFrom) : '--'}}</span>
        <span>代理商：{{order.clientOrganization.fullName ? order.clientOrganization.fullName : '--'}}</span>
        <span>下单时间：{{formatDateObject(order.createdTime)}}</span>
      </wt-box>
    </wt-grid>
    <pt-sub-title title="计算结果及检测报告"></pt-sub-title>
    <wt-grid :col="3" grid-gap="10px" :class="$style['order-info__box']" v-if="order">
      <wt-box :class="$style['order-info']">
        <span v-if="order.reportJobId">
          计算结果：{{`${order.patient.name}（${order.sampleId}）`}}
            <router-link :to="resultUrl" :class="$style.aColor">
              查看计算结果
            </router-link>
          </span>
          <span v-if="order.reportJobId">
            在线报告：{{`${order.patient.name}（${order.sampleId}）`}}
            <a @click="showReport=true" :class="$style.aColor">查看在线报告</a>
          </span>
          <span v-if="order.reportOssUrls">
            PDF报告：{{`${order.patient.name}（${order.sampleId}）`}}
            <p v-for="(file,i) in order.reportOssUrls" :key="i" style="margin-left:60px;">
              <template v-if="file">
                {{getFileName(file)}}
              <a :href="$previewResourceUrl+file.replace(/\+/g, '%2B')" target="_blank" :class="$style.aColor">
              查看报告
              </a><br>
              </template>

            </p>

          </span>
      </wt-box>
    </wt-grid>
    <!-- 附件信息 -->
    <template v-if="order && order.attachments">
      <pt-sub-title title="相关文件"></pt-sub-title>
      <wt-grid :col="1" grid-gap="10px" :class="$style['order-info__box']">
        <a :href="$privateResourcesUrl+file.ossUrl.replace(/\+/g, '%2B')" target="_blank" style="dispaly:block;color:#EDBE83;" v-for="(file,index) in order.attachments" :key="index">{{file.name || file.ossUrl}}</a>
      </wt-grid>
    </template>
    <!-- 操作记录：只记录特殊操作的 -->
    <pt-sub-title title="操作记录"></pt-sub-title>
    <wt-grid :col="1" grid-gap="10px" :class="$style['order-info__box']">
      <wt-box :class="$style['special-operate']" v-for="(log,key) in logs" :key="key">
        <template v-if="log.orderStatusResult==='SAMPLE_RECOLLECT'">
          <span>{{formatDateObject(log.operationTime)}}</span>
          <span>
            创建第{{log.recollectTimes}}次重采订单
            <router-link v-if="order.sampleId !== log.newSampleId" :to="`/adult-sell-order-detail/${log.newOrderId}`" :class="$style.maincolor">{{log.newSampleId}}</router-link>
            <span :class="$style.maincolor" v-else>{{log.newSampleId}}</span>
            原始样本条码号：
            <router-link v-if="order.sampleId !== log.sampleId" :to="`/adult-sell-order-detail/${log.orderId}`" :class="$style.maincolor">{{log.sampleId}}</router-link>
            <span v-else :class="$style.maincolor">{{log.sampleId}}</span>
          </span>
        </template>
        <template v-else>
          <span>{{formatDateObject(log.operationTime)}}</span>
          <span>
            {{orderflowHelper.formatTargetOrderStatus(log.orderActions)}}
          </span>
          <span>{{log.auditInformation.operatorName + formatOperationLog(log.orderStatusResult)}}</span>
          <span v-if="log.reason">原因是：{{log.reason}}</span>
        </template>
      </wt-box>
    </wt-grid>
    <pt-sub-title title="历史检测"></pt-sub-title>
    <wt-grid :col="1" grid-gap="10px" :class="$style['order-info__box']" v-if="order">
      <wt-box :class="$style['special-operate']" v-for="(item,i) in order.historyOrders" :key="i">
        <span>订单号：{{item.id}}</span>
        <span>商品名称：{{item.detectionPackageNames ? item.detectionPackageNames.toString() : '--'}}</span>
        <span>样本条码号：<router-link target="_blank" :to="{ path: `/adult-sell-order-detail/${item.id}` }">
        <a style="color:#EDBE7C">{{item.sampleId}}</a>
        </router-link>
        </span>
      </wt-box>
    </wt-grid>
    <el-button size="small" type="primary" v-if="HAS_PERM_ADULTLAB_EDIT_ORDER" @click="goEdit(order.id)" style="margin-top:.3rem">编辑订单信息
    </el-button>
    <el-button size="small" type="danger" v-if="HAS_PERM_ADULTLAB_DELETE_ORDER" @click="goDelete(order.id)">删除订单</el-button>
  </div>
</template>

<script>
// 组件class前缀
import ptLegend from 'cps/base/pt-legend'
import ptLabOrderProgress from './pt-adult-sell-order-progress'

import {
  genderFormat,
  formatDate,
  formatDateObject,
  birthdayToAge
} from '@/utils/formUtils'
import orderflowHelper from '@/config/order'
import orderStatus from 'cps/lab-order/order-status'
import {
  formatOperationLog,
  formatSaleFrom
} from 'enumeration/lab-order.js'
import {
  certificatesTypeMap
} from 'json/lab-order'
import {
  sampleType
} from 'json/goods-order-options'
import {
  getEnumeration
} from 'enumeration'
import {
  hasPermissions
} from 'utils/permissions'
import { getDayTypes } from 'enumeration/mall.js'
const prefixCls = 'pt-adult-sell-order-detail'
const PERM_ADULTLAB_EDIT_ORDER = 'PERM_ADULTLAB_EDIT_ORDER'
// 实验室订单删除功能权限
const PERM_ADULTLAB_DELETE_ORDER = 'PERM_ADULTLAB_DELETE_ORDER'
const PERM_ADULTLAB_OPERATION = 'PERM_ADULTLAB_OPERATION'
export default {
  name: 'pt-adult-sell-order-detail',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    isComplete () {
      return this.order && this.order.nextOrderAction === 'NONE'
    },
    nextStatus () {
      return this.order.nextOrderAction || ''
    },
    resultUrl () {
      return '/show-calculate-result/' + this.order.reportJobId
    },
    HAS_PERM_ADULTLAB_EDIT_ORDER () {
      return this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions,
        PERM_ADULTLAB_EDIT_ORDER)
    },
    HAS_PERM_ADULTLAB_DELETE_ORDER () {
      return this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions,
        PERM_ADULTLAB_DELETE_ORDER)
    },
    HAS_PERM_ADULTLAB_OPERATION () {
      console.log('============this.$auth.user().permissions', this.$auth.user().permissions)
      return this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions,
        PERM_ADULTLAB_OPERATION)
    },
    showWarning () {
      let status = orderflowHelper.formatOrderActions(this.order.nextOrderAction)
      return this.order.remainingDays !== null && this.order.remainingDays <= 3 && status !== '已完成' && this.order
        .orderStatusEnum !== 'CLOSED'
    },
    warningInfo () {
      return `预计交付日期${formatDate(this.order.expectedDeliveryDate)}，剩余${this.order.product.dayType ? getDayTypes(this.order.product.dayType) : ''}${this.order.remainingDays}`
    },
    orderDetail () {
      let orderInfoShow = []
      if (this.task) {
        let data = this.task.orderActionData.statusDetail
        if (data) {
          orderInfoShow.push(
            this.getObj(orderflowHelper.formatTargetOrderStatus(data.action, true), '不合格'),
            this.getObj('原因', data.reason || '--'),
            this.getObj('备注', data.comment || '--')
          )
        }
      } else {
        for (let i = 0; i < this.statuses.length; i++) {
          let action = this.statuses[i].action
          let changeAction = orderflowHelper.formatTargetOrderStatus(action, true)
          let reason = this.statuses[i].reason
          let comment = this.statuses[i].comment
          if (action === 'LAB_SAMPLES_RECEIVED') {
            if (reason) {
              orderInfoShow = this.getTasksOrder(action, reason, comment)
            } else {
              orderInfoShow.push(
                this.getObj(changeAction, '合格'),
                this.getObj('生产条码号', this.order.labCode ? this.order.labCode : '--'),
                this.getObj('备注', comment || '--')
              )
            }
          } else if (action === 'PREPARED') {
            if (reason) {
              orderInfoShow = this.getTasksOrder(action, reason, comment)
            } else {
              orderInfoShow.push(
                this.getObj(changeAction, '合格'),
                this.getObj('备注', comment || '--')
              )
            }
          } else if (action === 'WAREHOUSING') {
            orderInfoShow.push(
              this.getObj('冻存位置', this.order.otherInfo.frozenStorageLocation)
            )
          }
        }
      }
      return orderInfoShow
    }
  },
  props: {
    statuses: {
      type: Array,
      default: () => []
    },
    task: {
      type: Object
    },
    order: {
      type: Object,
      default: () => {}
    },
    tasks: {
      type: Array,
      default: () => []
    },
    logs: {
      type: Array,
      default: () => []
    },
    sampleRecollectLogs: {
      type: Array,
      default: () => []
    },
    reportVisable: {
      type: Boolean,
      default: false
    },
    hasSample: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      certificatesTypeMap: certificatesTypeMap,
      sampleType: sampleType,
      showReport: false,
      orderflowHelper: orderflowHelper,
      statusArray: [{
        color: '#70ad47',
        text: '正常'
      },
      {
        color: '#f56c6c',
        text: '异常'
      },
      {
        color: '#f69b07',
        text: '待处理'
      }
      ]
    }
  },
  components: {
    ptLegend,
    ptLabOrderProgress,
    orderStatus
  },
  methods: {
    getObj (name, text) {
      return { 'name': name, 'text': text }
    },
    getTasksOrder (status, reason, comment) {
      let obj = [
        this.getObj(orderflowHelper.formatTargetOrderStatus(status, true), '不合格'),
        this.getObj('原因', reason || '--'),
        this.getObj('备注', comment || '--')
      ]
      return obj
    },
    genderFormat,
    formatDate,
    formatDateObject,
    formatOperationLog,
    getEnumeration,
    birthdayToAge,
    formatSaleFrom,
    reload () {
      this.$emit('on-reload')
    },
    isLoading (val) {
      this.$emit('handle-loding', val)
      // this.loading = val
    },
    getFileName (fileUrl) {
      let arr = fileUrl.split('/')
      return arr[arr.length - 1]
    },
    goEdit (id) {
      this.$router.push(`/sell-order-form/true/${id}`)
    },
    toOperation () {
      this.$store.dispatch('toVisibleReport', this.order.id).then((response) => {
        this.$parent.getReportDetail()
        // this.$store.dispatch('ReportDetail', this.order.id).then((response) => {
        //   this.reportVisable = response.data.visible
        // })
        // this.getReportDetail()
      }).catch((error) => {
        console.error(error)
      })
    },
    goDelete (id) {
      this.$confirm('点击“确定”，将永久删除本订单并不能恢复，请谨慎操作。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$emit('handle-loding', true)
        this.$store.dispatch('adultDeleteLabOrder', id).then((response) => {
          this.$emit('handle-loding', false)
          this.reload()
          // this.$message.success('请在“异常订单”页面确认删除订单')
          // history.go(-1)
        }).catch((error) => {
          this.$emit('handle-loding', false)
          console.error(error)
          this.$message.error(error + '删除订单失败！')
        })
      })
    }
  }
}

</script>

<style module lang="less">
  @import '~less/var.less';

  /* 已启用css module， template中请使用$style.className添加class */
  /* 务必遵循css BEM原则 */
  .order-message-id {
    padding: 0 0 0 10px;

    span {
      color: #edbe81 !important
    }
  }

  .pt-adult-sell-order-detail {
    :global .el-radio {
      &+.el-radio {
        margin-left: 30px;
      }
    }
  }

  .order-info__box {
    padding: 10px 20px;
  }

  .order-info {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;

    span {
      font-size: 14px;
      color: #666;
      line-height: 30px;
    }
  }

  .order_progress {
    margin-top: 30px;
  }

  .special-operate {
    display: block;

    span {
      margin-right: 30px;
      color: #666;
      line-height: 30px;
    }
  }

  .maincolor {
    color: @mainColor  !important;
    display: inline-block;
    margin: 0 10px !important;
  }

  .specialColor {
    color: @mainColor  !important;
  }

  .aColor {
    color: @mainColor  !important;
    margin-left: 10px;
    text-decoration: none;
  }

</style>
